import * as React from 'react';
import { StaticContext } from 'react-router';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Container from 'components/Container';
import LinkButton from 'common/components/LinkButton';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Done';
import { Routes } from 'routing';
import { useTranslation } from 'services/localization/useTranslation';

type RentalType = 'rent-now' | 'reservation' | 'paylink';

type LocationState = {
	bookingId: string;
};

type Props = WithStyles<typeof styles> &
	RouteComponentProps<{ rentalType: RentalType }, StaticContext, LocationState>;

const ReservationDone = (props: Props) => {
	const classes = props.classes;
	const state: { bookingId: string } = props.location.state;
	const { t } = useTranslation();
	if (!state) {
		return <Redirect to="'/new-rental'" />;
	}
	const bookingId = state.bookingId;
	return (
		<Container className={classes.root}>
			<div className={classes.doneWrapper}>
				<CheckIcon className={classes.checkIcon} />
				<Typography variant="h6">
					{t('payLinkConfirm.reservationSaved', 'Reservation saved!')}
				</Typography>
			</div>
			<div className={classes.btnBlockWrapper}>
				<LinkButton variant="contained" color="primary" to={Routes.NEW_RENTAL}>
					{t('payLinkConfirm.takeNewRental', 'Make a new rental')}
				</LinkButton>
			</div>
			<div className={classes.btnBlockWrapper}>
				<LinkButton variant="outlined" color="primary" to={Routes.BookingPage(bookingId)}>
					{t('common:actions.continueToReservation', 'Continue to reservation')}
				</LinkButton>
			</div>
		</Container>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			flex: '1 1 auto',
		},
		sentInfo: {
			marginBottom: 32,
		},
		btnBlockWrapper: {
			display: 'block',
			textAlign: 'center',
			margin: 8,
		},
		link: {
			color: theme.palette.primary.main,
		},
		checkIcon: {
			color: 'green',
			fontSize: 56,
			marginRight: 16,
		},
		doneWrapper: {
			display: 'flex',
			margin: '16px auto',
			alignItems: 'center',
		},
	});

export default withStyles(styles)(ReservationDone);
